import React, { forwardRef } from 'react';

const Textarea = forwardRef((props, ref) => {
    return <textarea ref={ref} className="nd-textarea" {...props} />;
});
Textarea.defaultProps = {
    rows: 3,
};
export default Textarea;
